import { motion } from "framer-motion";
import { PageThumb } from "./shared";

export const ThumbnailPanel = ({ loading, error, thumbs, totalPages, truncated, editable, redactions, onAdd, onRemove, fileCount, rectClassName = null, rectLabel = "", editableLabel = "Draw permanent blackouts" }) => (
  <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }}
    transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
    className="px-5 pt-4 overflow-hidden" data-testid="thumbnail-panel">
    <div className="border border-hairline rounded-lg bg-page p-3">
      <div className="flex items-center justify-between mb-3 gap-3">
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-mist">
          {fileCount > 1 ? "Previewing first document" : editable ? editableLabel : "Live page preview"}
        </span>
        <span className="font-mono text-[10px] text-fog" data-testid="thumbnail-count">
          {loading ? "Rendering…" : `${thumbs.length}${truncated ? ` of ${totalPages}` : ""} page${totalPages === 1 ? "" : "s"}`}
        </span>
      </div>
      {loading && (
        <div className="flex gap-3 overflow-hidden" data-testid="thumbnail-loading">
          {[0, 1, 2].map((i) => <div key={i} className="h-36 w-28 shrink-0 rounded-md bg-white border border-hairline animate-pulse" />)}
        </div>
      )}
      {!loading && error && (
        <p className="font-mono text-xs text-fog" data-testid="thumbnail-error">Preview unavailable — processing still works.</p>
      )}
      {!loading && !error && thumbs.length > 0 && (
        <>
          <div className={editable ? "grid grid-cols-2 gap-3 max-h-[520px] overflow-y-auto pr-1 bg-[#1F1F1F] rounded-sm p-3" : "flex gap-3 overflow-x-auto pb-1"}>
            {thumbs.map((p) => (
              <PageThumb
                key={p.page}
                page={p}
                rects={redactions.filter((r) => r.page === p.page)}
                editable={editable}
                compact={!editable}
                onAdd={onAdd}
                onRemove={onRemove}
                rectClassName={rectClassName}
                rectLabel={rectLabel}
              />
            ))}
          </div>
          {truncated && <p className="font-mono text-[10px] text-mist mt-3">Preview shows the first 30 pages. Text redaction can still search the full document.</p>}
        </>
      )}
    </div>
  </motion.div>
);
